import type { WeddingVideo } from '../types/thankYou'

export const weddingVideos: WeddingVideo[] = [
  { id: 'ibeByUuVOLo', couple: 'Sarah & Samuel' },
  { id: '4Ja0qCUKxS4', couple: 'Jessie & Wesley' },
  { id: 'OKuPMQSUS14', couple: 'Lindsey & Robert' },
  { id: 'nQLpB_2SxRA', couple: 'Laura & Grace' },
  { id: 'dtU4sWV1nDU', couple: 'Christine & Jamie' },
  { id: 'grrSdimY2nI', couple: 'Angela & Todd' },
]
